import { Button } from 'antd'
import styled from 'styled-components'

export const Root = styled.div`
    position: relative;
    width: 218px;
    height: 170px;
    border: 2px solid black;

    * {
        box-sizing: border-box;
    }
`

export const Num = styled.input`
    display: block;
    text-align: center;
    width: 100%;
    height: 47%;
    font-size: 76px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 2px solid black;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    outline: none;
`

export const Sizes = styled.div`
    height: 16%;
    display: flex;
    justify-content: center;
    background-color: #9fc5e8;
    border-bottom: 2px solid black;
    font-size: 22px;
    font-weight: bold;
`

export const SizesWidth = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const SizesLength = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const SizesSeparator = styled.div`
    width: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const Shape = styled.div`
    height: 10%;
    text-transform: uppercase;
    border-bottom: 2px solid black;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
`

export const Space = styled.div`
    height: 9%;
    border-bottom: 2px solid black;
`

export const Footer = styled.div`
    display: flex;
    height: 18%;
`

export const RangeAndDate = styled.div`
    height: 100%;
    width: 60%;
    padding-left: 4px;
`

export const Roller = styled.div`
    height: 100%;
    width: 44%;
    display: flex;
    justify-content: end;
    align-items: center;
    text-align: right;
    font-size: 15px;
    line-height: 1;
    font-weight: bold;
    padding-right: 4px;
`

export const Range = styled.div`
    height: 46%;
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    padding-left: 6px;
`

export const Date = styled.div`
    height: 54%;
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: bold;
    background-color: #b6d7a8;
    border-left: 1px solid black;
    border-top: 1px solid black;
    padding-left: 6px;
`

export const Remove = styled(Button)`
    position: absolute;
    right: -12px;
    top: -12px;
`
